"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActiveElement = void 0;

var getActiveElement = function getActiveElement() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.activeElement;
  var options = arguments.length > 1 ? arguments[1] : undefined;

  // To get activeElement even in closed shadow dom
  if (element && options && options.closedShadowDom) {
    return element.getRootNode() && element.getRootNode().activeElement;
  }

  var shadowRoot = element.shadowRoot;
  var contentDocument = element.contentDocument;

  if (shadowRoot && shadowRoot.activeElement) {
    return getActiveElement(shadowRoot.activeElement);
  }

  if (contentDocument && contentDocument.activeElement) {
    return getActiveElement(contentDocument.activeElement);
  }

  return element;
};

exports.getActiveElement = getActiveElement;